export const FormsName = 'formsComponent';
